<template>
<m-pageframe
    title="{organization_label}: Analytics"
>
<v-container>

     <v-list-item
        v-for="(item, index) in pages"
        :key="index"
        v-on:click="onClickPage(item)"
    >
        <v-list-item-icon><v-icon>{{item.icon}}</v-icon></v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title>{{item.title}}</v-list-item-title>
        </v-list-item-content>
        <v-list-item-icon><v-icon>mdi-arrow-right</v-icon></v-list-item-icon>
    </v-list-item>

    <p
        style="margin-top: 15px"
    >
        <b>Note:</b> RedChirp is much more than just Web Chat!  We are working on adding more analytics -- expect more analytics soon!
    </p>

</v-container>
</m-pageframe>
</template>

<script>
export default {
    methods: {
        onClickPage(page) {
            this.$router.push({
                'name': page.page,
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                },
                'query': page.query
            });
        }
    },
    computed: {
        pages() {
            let ret = [];

            ret.push({'icon': 'mdi-chat-outline', 'title':'Web Chat Requests', 'page': 'analytics-web-chat'});
            ret.push({'icon': 'mdi-comment-text-multiple', 'title':'All Bulk Messages', 'page': 'analytics-all-bulk-messages'});

            return ret;
        }
    },
}
</script>

<style lang="scss" scoped>
</style>